import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { Drawer, Box, List, ListItem } from '@material-ui/core';
import Footer from './Footer';

type MenuProps = {
    isOpen: boolean;
    items: ReactElement[];
    handleClose: () => void;
};

const StyledList = styled(List)`
    a {
        color: ${({ theme }) => theme.palette.text.primary};
        text-decoration: none;
        width: 100%;
    }

    padding: 10px !important;
    font-size: 0.9rem;
`;

const Divider = styled.hr`
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
    padding: 1px;
`;

const Menu: FC<MenuProps> = ({ isOpen, items, handleClose }) => {
    return (
        <Drawer open={isOpen} onClose={handleClose}>
            <Box
                sx={{ width: 300 }}
                role="presentation"
                onClick={handleClose}
                onKeyDown={handleClose}
            >
                <StyledList>
                    {items.map((element, index) => (
                        <>
                            <ListItem button key={index}>
                                {element}
                            </ListItem>
                            <Divider />
                        </>
                    ))}
                    <Footer />
                </StyledList>
            </Box>
        </Drawer>
    );
};

export default Menu;
